import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar, Cell } from 'recharts';
import { TrendingUpIcon, BanknoteIcon, ActivityIcon, MapPinIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const dailySalesData = [{
  day: '1',
  sales: 75000
}, {
  day: '2',
  sales: 82000
}, {
  day: '3',
  sales: 78000
}, {
  day: '4',
  sales: 91000
}, {
  day: '5',
  sales: 85000
}, {
  day: '6',
  sales: 95000
}, {
  day: '7',
  sales: 110000
}, {
  day: '8',
  sales: 88000
}, {
  day: '9',
  sales: 92000
}, {
  day: '10',
  sales: 86000
}, {
  day: '11',
  sales: 98000
}, {
  day: '12',
  sales: 105000
}, {
  day: '13',
  sales: 115000
}, {
  day: '14',
  sales: 125000
}, {
  day: '15',
  sales: 118000
}];
const regionalSalesData = [{
  region: 'Tembisa',
  sales: 850000
}, {
  region: 'Soweto',
  sales: 720000
}, {
  region: 'Kempton Park',
  sales: 450000
}, {
  region: 'Boksburg',
  sales: 380000
}, {
  region: 'Germiston',
  sales: 310000
}, {
  region: 'Benoni',
  sales: 240000
}];
const topVendors = [{
  rank: 1,
  name: 'Sipho Spaza Shop',
  location: 'Tembisa',
  sales: 145000,
  txns: 850,
  growth: '+12.5%'
}, {
  rank: 2,
  name: 'Mama Joy Supermarket',
  location: 'Soweto',
  sales: 132000,
  txns: 780,
  growth: '+8.2%'
}, {
  rank: 3,
  name: 'Kasi Convenience',
  location: 'Tembisa',
  sales: 115000,
  txns: 690,
  growth: '+15.1%'
}, {
  rank: 4,
  name: 'Boksburg Corner Store',
  location: 'Boksburg',
  sales: 98000,
  txns: 540,
  growth: '+5.4%'
}, {
  rank: 5,
  name: 'Thabo Electronics',
  location: 'Germiston',
  sales: 85000,
  txns: 420,
  growth: '-2.1%'
}, {
  rank: 6,
  name: 'Zanele Mini Market',
  location: 'Soweto',
  sales: 76000,
  txns: 410,
  growth: '+18.5%'
}, {
  rank: 7,
  name: 'Benoni Fresh Produce',
  location: 'Benoni',
  sales: 65000,
  txns: 380,
  growth: '+4.2%'
}, {
  rank: 8,
  name: 'Kempton Express',
  location: 'Kempton Park',
  sales: 58000,
  txns: 310,
  growth: '+1.8%'
}];
export function SalesPerformance() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-2013">
      <div className="mb-8" data-id="element-2014">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2015">
          Sales Performance
        </h1>
        <p className="text-gray-500" data-id="element-2016">
          Track vendor sales metrics, trends, and regional performance.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-2017">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-2018">
          <div className="p-3 bg-mavis-teal/10 text-mavis-teal rounded-none" data-id="element-2019">
            <BanknoteIcon className="w-5 h-5" data-id="element-2020" />
          </div>
          <div data-id="element-2021">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-2022">
              Total Sales (MTD)
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-2023">
              {formatZAR(2450000)}
            </p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-2024">
          <div className="p-3 bg-mavis-blue/10 text-mavis-blue rounded-none" data-id="element-2025">
            <ActivityIcon className="w-5 h-5" data-id="element-2026" />
          </div>
          <div data-id="element-2027">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-2028">
              Transactions Today
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-2029">1,245</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-2030">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-2031">
            <TrendingUpIcon className="w-5 h-5" data-id="element-2032" />
          </div>
          <div data-id="element-2033">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-2034">
              Avg Transaction
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-2035">
              {formatZAR(196)}
            </p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-2036">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-2037">
            <MapPinIcon className="w-5 h-5" data-id="element-2038" />
          </div>
          <div data-id="element-2039">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-2040">
              Top Region
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-2041">Tembisa</p>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-none shadow-sm border border-gray-200 mb-8" data-id="element-2042">
        <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-2043">
          Daily Sales Trend (Last 30 Days)
        </h2>
        <div className="h-80" data-id="element-2044">
          <ResponsiveContainer width="100%" height="100%" data-id="element-2045">
            <AreaChart data={dailySalesData} margin={{
            top: 10,
            right: 10,
            left: 0,
            bottom: 0
          }} data-id="element-2046">

              <defs data-id="element-2047">
                <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1" data-id="element-2048">
                  <stop offset="5%" stopColor="#0D4F5C" stopOpacity={0.3} data-id="element-2049" />
                  <stop offset="95%" stopColor="#0D4F5C" stopOpacity={0} data-id="element-2050" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-2051" />

              <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{
              fill: '#6b7280',
              fontSize: 12
            }} dy={10} data-id="element-2052" />

              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#6b7280',
              fontSize: 12
            }} tickFormatter={value => `R${value / 1000}k`} data-id="element-2053" />

              <Tooltip contentStyle={{
              borderRadius: '0',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} formatter={(value: number) => [formatZAR(value), 'Sales']} data-id="element-2054" />

              <Area type="monotone" dataKey="sales" stroke="#0D4F5C" strokeWidth={2} fillOpacity={1} fill="url(#colorSales)" data-id="element-2055" />

            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2056">
        <div className="lg:col-span-2 bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-2057">
          <div className="p-5 border-b border-gray-200 bg-gray-50" data-id="element-2058">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-2059">
              Top Performing Vendors
            </h2>
          </div>
          <div className="overflow-x-auto" data-id="element-2060">
            <table className="w-full text-left border-collapse" data-id="element-2061">
              <thead data-id="element-2062">
                <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-2063">
                  <th className="p-4 font-medium" data-id="element-2064">Rank</th>
                  <th className="p-4 font-medium" data-id="element-2065">Vendor Name</th>
                  <th className="p-4 font-medium" data-id="element-2066">Location</th>
                  <th className="p-4 font-medium text-right" data-id="element-2067">Sales MTD</th>
                  <th className="p-4 font-medium text-right" data-id="element-2068">Transactions</th>
                  <th className="p-4 font-medium text-right" data-id="element-2069">Growth %</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-2070">
                {topVendors.map((vendor, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-2071">
                    <td className="p-4 text-sm font-bold text-gray-900" data-id="element-2072">
                      #{vendor.rank}
                    </td>
                    <td className="p-4 text-sm font-medium text-gray-900" data-id="element-2073">
                      {vendor.name}
                    </td>
                    <td className="p-4 text-sm text-gray-600" data-id="element-2074">
                      {vendor.location}
                    </td>
                    <td className="p-4 text-sm font-mono font-bold text-gray-900 text-right" data-id="element-2075">
                      {formatZAR(vendor.sales)}
                    </td>
                    <td className="p-4 text-sm font-mono text-gray-600 text-right" data-id="element-2076">
                      {vendor.txns}
                    </td>
                    <td className={`p-4 text-sm font-mono font-bold text-right ${vendor.growth.startsWith('+') ? 'text-mavis-green' : 'text-red-500'}`} data-id="element-2077">

                      {vendor.growth}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-2078">
          <div className="p-5 border-b border-gray-200 bg-gray-50" data-id="element-2079">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-2080">Sales by Region</h2>
          </div>
          <div className="p-6 h-[400px]" data-id="element-2081">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2082">
              <BarChart data={regionalSalesData} layout="vertical" margin={{
              top: 0,
              right: 0,
              left: 20,
              bottom: 0
            }} data-id="element-2083">

                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f0f0f0" data-id="element-2084" />

                <XAxis type="number" axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} tickFormatter={value => `R${value / 1000}k`} data-id="element-2085" />

                <YAxis dataKey="region" type="category" axisLine={false} tickLine={false} tick={{
                fill: '#4b5563',
                fontSize: 12
              }} data-id="element-2086" />

                <Tooltip cursor={{
                fill: '#f3f4f6'
              }} contentStyle={{
                borderRadius: '0',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} formatter={(value: number) => [formatZAR(value), 'Sales']} data-id="element-2087" />

                <Bar dataKey="sales" radius={[0, 4, 4, 0]} barSize={24} data-id="element-2088">
                  {regionalSalesData.map((entry, index) => <Cell key={`cell-${index}`} fill={index === 0 ? '#EAB308' : '#0D4F5C'} data-id="element-2089" />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}